import { Component } from '@angular/core';
import { Chart } from 'chart.js';
import { Observable } from 'rxjs';
// import { SnotifyService } from 'ng-snotify';
import { SwPush, SwUpdate } from '@angular/service-worker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationsService } from './services/notifications.service';
import { UserService } from './services/user.service';
import { FeedbackService } from './services/feedback.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { CompanyDetailsService } from './services/company-details.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  public style = 'material';
  public body = 'Lorem ipsum dolor sit amet!';
  public timeout = 3000;
  public progressBar = true;
  public closeClick = true;
  public newTop = true;
  public filterDuplicates = false;
  public backdrop = -1;
  public dockMax = 8;
  public blockMax = 6;
  public pauseHover = true;
  public titleMaxLength = 15;
  public bodyMaxLength = 80;
  public onlineStatus = true;
  public toast;
  // public student_id;
  public snackBarRef;
  title = 'app';
  message: any = 'message';
  update: boolean = false;
  readonly VAPID_PUBLIC_KEY = "BIrxCacdxpxiM2l5GWMDEsgEAfJA8lmZP7p7n9cQW6EfibpgBFiPz3PEPv2_AXUWyFE8fXEt2BqxhaAYgv3T_70";
  constructor (updates: SwUpdate, public snackBar: MatSnackBar, private _userService: UserService, private swPush: SwPush,
    private _notificationsService: NotificationsService, private _feedbackService: FeedbackService,
    private company: CompanyDetailsService,
    public bottomSheet: MatBottomSheet) {

    const self = this;
    // updates.available.subscribe( event => {
    //   this.update = true;
    //   // this.Notify.html("A new version is available",{
    //   //   timeout:40000,
    //   //   pauseOnHover:false,
    //   //   showProgressBar:false,
    //   //   buttons:[
    //   //     {text : 'UPDATE',action: () =>   updates.activateUpdate().then(()=>document.location.reload())},
    //   //     {text: 'CANCEL', action: () => ''}
    //   //   ]
    //   // });

    //   let sheetRef = this.bottomSheet.open(ConfirmSnackbarComponent,{
    //     data:{message:"A new version is available. Do you want to reload?", button1: 'yes', button2: 'no'}
    //  })
    //   sheetRef.afterDismissed().subscribe(data => {
    //     console.log(data);
    //     if(data){
    //       if(data.response){
    //         updates.activateUpdate().then(()=>document.location.reload());
    //         console.log('new version loaded');
    //       }
    //     }
    //   })

    // });

    updates.available.subscribe(event => {
      this.snackBarRef = this.snackBar.open('A new version is available', "Update");
      setTimeout(() => {
        this.snackBarRef.dismiss();
      }, 50000);
      this.snackBarRef.onAction().subscribe(() => {
        updates.activateUpdate().then(() => document.location.reload());
      });

      this.update = true;

    });

    window.addEventListener('offline', function () {
      self.snackBar.open('You are offline', 'Dismiss');
    });
    window.addEventListener('online', function () {
      self.snackBar.dismiss();
    });
    this.swPush.requestSubscription({
      serverPublicKey: this.VAPID_PUBLIC_KEY
    }).then(sub => {
      this._userService.getUserData().subscribe(data => {
        let trans = { 'username': data.student_id, 'sub': sub };
        this._notificationsService.saveEndpoint(trans).subscribe(data => {
          this._notificationsService.addPushSubscriber(trans).subscribe(res => {
          })
        })

      })



    })

    this.showMessages();

    this._feedbackService.changeEmitted$.subscribe(data => {
      if (data.message != "") {
        this.snackBar.open(data.message, 'close', {
          panelClass: data.type,
          duration: 3000
        });

      }
    })


  }

  ngOnInit () {
    // this.swPush.requestSubscription({
    //   serverPublicKey : this.VAPID_PUBLIC_KEY
    // }).then(sub => {
    //   this._notificationsService.addPushSubscriber(sub).subscribe();
    // })

    // this._userService.getUserData().subscribe(data => {
    //   this.student_id = data?.student_id;
    // });
    // window.console = {};

    this.company.getDetails().subscribe(data => {
      try {
        var link = document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'icon';
        link.href = data.logo;
        document.title = `${data.adm_initial.toUpperCase()} Student Portal`;
        document.getElementsByTagName('head')[0].appendChild(link);
      } catch (error) {
        console.log(error);
      }
    })

  }

  subscribeToNotifications () {
    this.message = this.message + ' is here';
  }

  showMessages () {

    this.swPush.messages
      .subscribe(message => {
        this._notificationsService.notificationMessage(message);

      })

  }



}
